<template>
  <Card class="pb-3">
    <CardHeader class="font-semibold text-lg sm:text-xl px-4 sm:px-6 relative">
      <div class="flex justify-between items-center">
        <span>{{ title }}</span>
        <slot name="top-right" />
      </div>
    </CardHeader>
    <CardContent
      :class="
        cn(
          'grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 pb-2 px-4 sm:px-6',
          props.class
        )
      "
    >
      <slot />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardHeader, CardContent } from ".";
import type { HTMLAttributes } from "vue";
import { cn } from "../../lib/utils";

const props = defineProps<{
  title: string;
  class?: HTMLAttributes["class"];
}>();
</script>
